// @flow

import React from 'react';
import { Heading } from 'operation-diameter';

import { useCopy } from 'hooks/useCopy';
import { loanTermRadios } from 'shared/utils/constants';
import EnhancedRadioGroup from 'shared/components/EnhancedRadioGroup';

import type { Field } from 'hooks/useField';

const LoanTerm = ({ loanTermField }: { loanTermField: Field }) => {
  const { getCopy } = useCopy();

  return (
    <>
      <>
        <Heading headingSize='h6'>{getCopy('eligibility.term.title')}</Heading>
        <EnhancedRadioGroup
          legend={'Select a term'}
          isLegendVisible={false}
          radios={loanTermRadios}
          name='loan-term'
          onChange={(loanTermValue) => loanTermField.set(loanTermValue)}
          selectedValue={loanTermField.value}
          error={!!loanTermField.error}
        />
      </>
    </>
  );
};

export default LoanTerm;
